// extracted by mini-css-extract-plugin
export default {"giftOrPromoRowWrapper":"xu-z","giftOrPromoSelector":"yu-z","disabled":"zu-z","subTitle":"Au-z","selectShipAddressMessage":"Bu-z","changePayment":"Cu-z"};